<template>
    <div class="card-deal-main mb10">
        <el-row class="pb10" v-if="canViewField('status') && isValueVisible(status, 'status')">
            <div :class="[{'status-select-area': editMode }]" @click.stop="showStatusSelectForm">
                <el-col :span="9" class="status-value">
                    <span v-show="status">
                        {{ status.name }}
                    </span>
                </el-col>
                <el-col :span="15" v-if="status.id" class="status-line">
                    <template v-if="status.id <= 8">
                        <span v-for="statusOrder in status.id" :key="statusOrder" class="status" :class="`order-${statusOrder}`"></span>
                    </template>
                    <template v-else-if="status.id <= 10">
                        <span v-for="statusOrder in 8" :key="statusOrder" class="status" :class="`order-${statusOrder}`"></span>
                        <span class="status" :class="`order-${status.id}`"></span>
                    </template>
                    <template v-else>
                        <span class="status" :class="`order-${status.id}`"></span>
                    </template>
                </el-col>
            </div>
            <el-row v-if="statusNeedComment">
                <el-col :span="24">
                    <div class="input-label-sm-text">
                        Причина отказа
                    </div>
                    <el-select
                        v-model="refuse_reason_id"
                        filterable
                        reserve-keyword
                        size="mini"
                        placeholder="Выберите причину отказа"
                    >
                        <el-option
                            v-for="item in reasonsRefuse"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                    <div class="error" v-if="errors.refuseReasonId">
                        {{ errors.refuseReasonId[0] }}
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="input-label-sm-text">
                        Комментарий
                    </div>
                    <div>
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 5}"
                            placeholder=""
                            v-model="reason_comment"
                        />
                    </div>
                    <div class="error" v-if="errors.notTargetReason">
                        {{ errors.reasonComment[0] }}
                    </div>
                </el-col>
            </el-row>
        </el-row>
        <el-row v-if="canViewField( 'tags') && isValueVisible(tag_ids)">
            <el-col v-if="editMode && canEditField( 'tags')">
                <el-select
                    v-model="tag_ids"
                    placement="bottom"
                    popper-class="popper-dropdown"
                    filterable
                    multiple
                    clearable
                    :allow-create="canEditTags"
                    default-first-option
                    autocomplete
                    placeholder="Теги"
                    size="mini"
                >
                    <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-col>
            <el-col v-else>
                <span v-for="tag in deal.tags" :key="tag.id" class="tag">
                    {{ '# ' + tag.name }}
                </span>
            </el-col>
        </el-row>
        <el-popover
            class="status-popover"
            ref="status-select"
            placement="top"
            title=""
            width="570"
            trigger="manual"
            v-model="isStatusSelectVisible"
            :visible-arrow="false"
            popper-class="status-select"
            v-on-clickaway="hideStatusSelectForm"
        >
            <div
                v-for="statusItem in statusList"
                :key="statusItem.id"
                :class="[{ 'status-select-active': statusItem.id === status_id }, { 'status-select-row': !statusItem.disabled }]"
                @click="selectStatus(statusItem.id)"
            >
                <span class="status" :class="`order-${statusItem.id}`"></span>
                <span class="title">
                    {{ statusItem.name }}
                </span>
            </div>
        </el-popover>
    </div>
</template>

<script>
import { cardMixin } from '@/mixins/card';
import { mixin as clickaway } from 'vue-clickaway';
import { eventBus } from '@/common/eventBus';
import localReferences from '@/helpers/localReferences';
import RefuseReason from '@/components/ContactDealCard';

export default {
    name: 'KeyInfo',
    mixins: [
        cardMixin,
        clickaway
    ],
    data() {
        return {
            isStatusSelectVisible: false,
            loadedStatusId: null
        };
    },
    computed: {
        deal() {
            return this.$store.state.deals.current;
        },
        tagList() {
            return this.$store.state.references.tags;
        },
        officeList() {
            return this.$store.state.references.offices;
        },
        office_id() {
            return this.$store.state.deals.current.office_id;
        },
        status() {
            return this.getItemFromLisById(this.status_id, this.statusList);
        },

        office() {
            return this.getItemFromLisById(this.office_id, this.officeList);
        },
        tag_ids: {
            get() {
                return this.$store.state.deals.current.tag_ids;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'tag_ids', value });
            }
        },
        canEditTags() {
            const roles = this.$store.state.auth.roles;
            const approvedRoles = ['office_manager', 'head_office'];
            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));

            return intersection.length > 0;
        },
        statusList() {
            const statuses = this.$store.state.references.dealStatuses;
            if (this.loadedStatusId && this.deal.id !== null && !this.canEditStatusFull) {
                return statuses.filter(item => item.id >= this.loadedStatusId && item.order).concat(statuses.filter(item => item.order === null));
            }
            if (!this.canEditRefuseBeforeMetering) {
                statuses.find(function(elem) {
                    if (elem.id === localReferences.dealStatuses.refuseBeforeMetering) {
                        elem.disabled = true;
                    }
                });
            }
            if (!this.canEditTechRefusalStatus) {
                statuses.find(function(elem) {
                    if (elem.id === localReferences.dealStatuses.techRefusal) {
                        elem.disabled = true;
                    }
                });
            }
            return statuses;
        },
        statusNeedComment() {
            return this.deal.status_id === localReferences.dealStatuses.closedNotImplemented || this.deal.status_id === localReferences.dealStatuses.refuseBeforeMetering;
        },
        reasonsRefuse() {
            if (this.statusNeedComment) {
                return this.$store.state.references.reasonsRefuse.filter(reason => reason.status === localReferences.reasonsRefuse.status_target);
            }

            return this.$store.state.references.reasonsRefuse;
        },
        canEditStatusFull() {
            return this.$store.getters.dealPermissions.find(item => item === 'deal_edit_status_id_full') !== undefined;
        },
        status_id: {
            get() {
                return this.$store.state.deals.current.status_id;
            },
            set(value) {
                if (!this.canEditTechRefusalStatus && value === localReferences.dealStatuses.techRefusal) {
                    return;
                }
                this.$store.commit('deals/setCurrentField', { field: 'status_id', value });
            }
        },
        refuse_reason_id: {
            get() {
                return this.$store.state.deals.current.refuse_reason_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'refuse_reason_id', value });
            }
        },
        reason_comment: {
            get() {
                return this.$store.state.deals.current.reason_comment;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'reason_comment', value });
            }
        },
        canEditTechRefusalStatus() {
            const roles = this.$store.state.auth.roles;
            const approvedRoles = ['deal_ceo', 'deal_financial_director', 'deal_head_service'];
            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));

            return intersection.length > 0;
        },
        canEditRefuseBeforeMetering() {
            return !Object.keys(this.$store.state.auth.roles).includes('deal_measurer');
        }
    },
    methods: {
        selectStatus(statusId) {
            if (!this.canEditRefuseBeforeMetering && statusId === localReferences.dealStatuses.refuseBeforeMetering) {
                return;
            }
            if (!this.canEditTechRefusalStatus && statusId === localReferences.dealStatuses.techRefusal) {
                return;
            }
            this.status_id = statusId;
            this.isStatusSelectVisible = false;
        },
        hideStatusSelectForm() {
            if (this.isStatusSelectVisible) {
                this.isStatusSelectVisible = false;
            }
        },
        showStatusSelectForm() {
            if (this.editMode && this.canEditField('status_id')) {
                this.isStatusSelectVisible = !this.isStatusSelectVisible;
            }
        }
    },
    watch: {
        status_id(newValue, oldValue) {
            if (oldValue === null) {
                this.loadedStatusId = newValue;
            }
        }
    },
    mounted() {
        eventBus.$on('status-updated', (statusId) => {
            this.loadedStatusId = statusId;
        });
    }
};
</script>
